import { render } from "./PreordersTable.vue?vue&type=template&id=734b582c&scoped=true"
import script from "./PreordersTable.vue?vue&type=script&lang=js"
export * from "./PreordersTable.vue?vue&type=script&lang=js"

import "./PreordersTable.vue?vue&type=style&index=0&id=734b582c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734b582c"]])

export default __exports__